import katex from 'katex';
import 'katex/dist/katex.min.css';

export const scrollIntoElement = (elementId) => {
  if (elementId) {
    setTimeout(() => {
      const ele = document.getElementById(elementId);
      if (ele) {
        ele.scrollIntoView({ behavior: 'smooth' });
      }
    }, 1);
  }
};

const unwrapLatexDelimiters = (raw) => {
  let latex = raw.trim();

  if ((latex.startsWith('$$') && latex.endsWith('$$') && latex.length > 4) ||
      (latex.startsWith('\\[') && latex.endsWith('\\]') && latex.length > 4)) {
    latex = latex.slice(2, -2).trim();
  } else if (latex.startsWith('\\(') && latex.endsWith('\\)') && latex.length > 4) {
    latex = latex.slice(2, -2).trim();
  } else if (latex.startsWith('$') && latex.endsWith('$') && latex.length > 2) {
    latex = latex.slice(1, -1).trim();
  }

  return latex;
};

export const renderKatex = (domNode) => {
  if (!domNode) return;

  const dataType = domNode.attribs?.['data-type'];
  const isInline = dataType === 'inline-math';
  const isBlock = dataType === 'block-math';
  if (!isInline && !isBlock) return;

  const katexStr = domNode.attribs['data-latex'];

  // Sometimes nodes generated by AI are not valid
  if (!katexStr || typeof katexStr !== 'string') return;

  const html = katex.renderToString(unwrapLatexDelimiters(katexStr), {
    throwOnError: false,
    displayMode: isBlock
  });

  return (
    <span
      className={isBlock ? 'my-2 block' : 'inline'}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
